import React, { useState } from "react";
import { FaCashRegister, FaPlus, FaMinus,FaQuestionCircle,  FaMoneyCheck, FaMoneyCheckAlt, FaUndo, FaSyncAlt, FaExchangeAlt, FaArrowDown, FaArrowUp, FaBalanceScale } from "react-icons/fa";
import * as FaIcons from "react-icons/fa";
import { BsClockHistory } from "react-icons/bs";
import { MdLocalPostOffice } from "react-icons/md";
import { RiHomeOfficeFill } from "react-icons/ri";
import Spinner from "../../../components/Spinner";
import { getUser, formatCurrency } from "../../../utils/Common";
import './index.css';
import Button from "react-bootstrap/Button";

const OfficeCard = ({
  office,
  handleTransaction,
  newBalance,
  handleNewBalanceChange,
  isLoading,
  handleReloadOfficeStatus,
  hasPendingRequest,
  viewType = "line" // "line", "grid", "table"
}) => {
  const [open, setOpen] = useState(false);
  const [isRotating, setIsRotating] = useState(false);
  const [isLoadingAdd, setIsLoadingAdd] = useState(false);
  const [isLoadingWithdraw, setIsLoadingWithdraw] = useState(false);
  const todayDate = new Date().toLocaleDateString('es-ES', {
    day: 'numeric',
    month: 'long',
    year: 'numeric'
  });
  const user = getUser();
  const balanceGeneral = office?.totalBalance + office?.TotalSaldoCajas - office?.TotalRemesasPorEntregar;

  const handleReloadClick = async (officeId) => {
    setIsRotating(true);
    await handleReloadOfficeStatus(officeId);
    setIsRotating(false);
  };

  const handleTransactionClick = async (office, amount, type) => {
    if (type === 3) setIsLoadingAdd(true);
    if (type === 4) setIsLoadingWithdraw(true);

    await handleTransaction(office, amount, type);

    if (type === 3) setIsLoadingAdd(false);
    if (type === 4) setIsLoadingWithdraw(false);
  };

  const renderFormGroup = (icon, label, tooltip, value) => (
    <div className="form-group">
      <div className="box-input-primary">
        {icon}
        {label}
        <span className="tooltip-asterisk"><FaQuestionCircle />
          <span className="tooltip-text">{tooltip}</span>
        </span>
      </div>
      <input type="text" className="form-control" value={formatCurrency(value)} readOnly />
    </div>
  );

  const renderTransactionSection = () => (
    <div className="transaction-container">
      {/* Tarjeta de Saldo Actual */}
      <div className="balance-card">
        <div className="balance-header">
          <span>Saldo actual</span>
          <span className="tooltip-icon">
            <FaQuestionCircle size={15}/>
            <span className="tooltip-text">Saldo disponible en la estafeta {office?.name}</span>
          </span>
        </div>
        <div className="balance-amount">
          {formatCurrency(office.totalBalance || 0)}
        </div>
      </div>

     {[4,9].includes(user.roleId) && (
      <>
            <div className="transaction-panel">
        <div className="d-flex flex-column flex-md-row gap-2">
            <div className="box-input-secondary">Monto</div>
              <input
                type="number"
                className="form-control"
                step="any"
                onChange={(e) => handleNewBalanceChange(e, office.IdCaja)}
                name="monto"
                placeholder="Introducir monto"
                value={newBalance[office.IdCaja] || ""}
              />
            </div>
              <button
                className="btn btn-blue  w-md-auto"
                onClick={() => handleTransactionClick(office, newBalance[office.IdCaja], 3)}
                disabled={!newBalance[office.IdCaja] || isNaN(Number(newBalance[office.IdCaja])) || hasPendingRequest}
              >
                {isLoadingAdd ? <Spinner type={1} size={15} /> : 'Añadir'}
              </button>
              <button
                className="btn btn-outline-blue w-md-auto"
                onClick={() => handleTransactionClick(office, newBalance[office.IdCaja], 4)}
                disabled={!newBalance[office.IdCaja] || isNaN(Number(newBalance[office.IdCaja])) || hasPendingRequest}
              >
                {isLoadingWithdraw ? <Spinner type={1} size={15} /> : 'Retirar'}
              </button>
          </div>
      </>
      )}
    </div>
  );

  const renderMovimientos = (icon, text, value ) => (
    <div className="mt-2">
    <div className="card-body p-1">
    {icon}
     {text}
      <span className="info-text">
        {value}
      </span>
    </div>
  </div>
  );

  if (viewType === "table") {
    return (
      <div className="office-table-row">
        <div className="office-table-cell">
          <div>{office?.name}</div>
        </div>
        <div className="office-table-cell">
          <div>{office?.code}</div>
        </div>
        <div className="office-table-cell">
          <div>{office?.nombreProvincia}</div>
        </div>
        <div className="office-table-cell">
          <div>{formatCurrency(office?.totalBalance || 0)}</div>
        </div>
        <div className="office-table-cell">
          {[4,9].includes(user.roleId) && (
            <div className="d-flex">
              <input
                type="number"
                className="form-control form-control-sm mr-2"
                style={{ width: "80px" }}
                onChange={(e) => handleNewBalanceChange(e, office.IdCaja)}
                name="monto"
                step="any"
                placeholder="Monto"
                value={newBalance[office.IdCaja] || ""}
              />
              <button
                className="btn btn-sm btn-blue mr-2"
                onClick={() => handleTransactionClick(office, newBalance[office.IdCaja], 3)}
                disabled={!newBalance[office.IdCaja] || isNaN(Number(newBalance[office.IdCaja])) || hasPendingRequest}
              >
                {isLoadingAdd ? <Spinner type={1} size={10} /> : '+'}
              </button>
              <button
                className="btn btn-sm btn-outline-blue mr-2"
                onClick={() => handleTransactionClick(office, newBalance[office.IdCaja], 4)}
                disabled={!newBalance[office.IdCaja] || isNaN(Number(newBalance[office.IdCaja])) || hasPendingRequest}
              >
                {isLoadingWithdraw ? <Spinner type={1} size={10} /> : '-'}
              </button>
            </div>
          )}
        </div>
      </div>
    );
  }

  if (viewType === "grid") {
    return (
      <div className="office-grid-card">
        <div className="office-grid-header">
          <div>
          <MdLocalPostOffice className="mr-1" size={20} />
            <strong>{office?.name}</strong>
            <div className="small text-muted">{office?.code}</div>
          </div>
          <FaSyncAlt
            size={14}
            style={{ cursor: "pointer", animation: isRotating ? "spin 2s linear infinite" : "none" }}
            onClick={() => handleReloadClick(office.id)}
          />
        </div>
        
        <div className="office-grid-info">
          <div className="office-grid-field">
            <label>Provincia:</label>
            <span>{office?.nombreProvincia}</span>
          </div>
          <div className="office-grid-field">
            <label>Ubicación:</label>
            <span>{office?.location}</span>
          </div>
          <div className="office-grid-field">
            <label>Saldo:</label>
            <span className="office-grid-saldo">{formatCurrency(office?.totalBalance || 0)}</span>
          </div>
          {hasPendingRequest && (
            <div className="alert alert-warning text-center" role="alert" style={{ marginBottom: "1rem", fontSize: "0.8rem" }}>
                 La última solicitud está en proceso. Por favor, espera a que sea aceptada, rechazada o cancelada.
          
            </div>
          )}
        </div>

        {[4,9].includes(user.roleId) && (
          <div className="office-grid-actions">
            <input
              type="number"
              className="form-control form-control-sm mb-2"
              onChange={(e) => handleNewBalanceChange(e, office.IdCaja)}
              name="monto"
              step="any"
              placeholder="Monto"
              value={newBalance[office.IdCaja] || ""}
            />
            <div className="office-grid-buttons">
              <button
                className="btn btn-sm btn-blue"
                onClick={() => handleTransactionClick(office, newBalance[office.IdCaja], 3)}
                disabled={!newBalance[office.IdCaja] || isNaN(Number(newBalance[office.IdCaja])) || hasPendingRequest}
              >
                {isLoadingAdd ? <Spinner type={1} size={10} /> : '+'}
              </button>
              <button
                className="btn btn-sm btn-outline-blue"
                onClick={() => handleTransactionClick(office, newBalance[office.IdCaja], 4)}
                disabled={!newBalance[office.IdCaja] || isNaN(Number(newBalance[office.IdCaja])) || hasPendingRequest}
              >
                {isLoadingWithdraw ? <Spinner type={1} size={10} /> : '-'}
              </button>
            </div>
          </div>
        )}
      </div>
    );
  }

  return (
    <div className="dashboardCard text-left" style={{ color: "black", marginBottom: "20px" }}>
      <div className="d-flex align-content-center justify-content-between" style={{ gap: 20 }}>
        <div className="form-group w-100">
          <label style={{ fontSize: "1.5rem", fontWeight: "bold" }}>
            <span>
              <MdLocalPostOffice className="" size={20} />
              {" "} {office.name}
            </span>
          </label>
        </div>
        <div className="text-center mt-lg-0 mt-sm-3">
          <label style={{ fontSize: "1.5rem", fontWeight: "bold" }}>
            <span>
              <FaSyncAlt className="" size={20} 
                style={{ cursor: "pointer", animation: isRotating ? "spin 2s linear infinite" : "none" }}
                onClick={() => handleReloadClick(office.IdCaja)}
              />
            </span>
          </label>
        </div>
        <hr/>
      </div>

      <div className="d-flex align-items-start mt-3" style={{ gap: 20 }}>
        <div className="form-group">
          <label>Ubicación</label>
          <input type="text" className="form-control" value={office?.location} readOnly />
        </div>
        <div className="form-group">
          <label>Código</label>
          <input type="text" className="form-control" value={office?.code} readOnly />
        </div>
      </div>

      <div className="text-left caja-movimientos">
        <div className="d-flex align-items-center">
          <BsClockHistory size={16} />
          <Button
            onClick={() => setOpen(!open)}
            aria-expanded={open}
            variant="link"
            className="toggle-button no-outline ml-2"
          >
            {open ? "Ocultar movimientos" : "Mostrar movimientos"}
          </Button>
        </div>

        <div className={`movimientos-info ${open ? "show" : "hide"}`}>
          <>
          {renderMovimientos(<FaPlus style={{ marginRight: '5px', color:"green"}} />, "Último monto asignado: ", formatCurrency(office?.UltimoMontoAgregado || 0))}
          {renderMovimientos(<FaMinus style={{ marginRight: '5px', color:"red" }} />, "Último monto retirado: ", formatCurrency(office?.UltimoMontoRestado || 0))}
          </>
        </div>
        {[4,9].includes(user.roleId) && hasPendingRequest && (
          <div className="alert alert-warning text-center" role="alert" style={{ marginBottom: "1rem" }}>
            La última solicitud está en proceso. Por favor, espera a que sea aceptada, rechazada o cancelada.
          </div>
        )}
      </div>
      {renderTransactionSection()}
      <hr/>
      <div className="d-flex" style={{ width: "100%" }}>
        <div className="d-flex flex-column" style={{ flex: 1, paddingRight: "1rem" }}>
          {renderFormGroup(
            <FaIcons.FaPlus style={{ marginRight: '5px' }} />,
            "Saldo total Asignado",
            `Total de dinero asignado a la estafeta el día ${todayDate}.`,
            office?.TotalSaldoAgregado || 0
          )}
          {renderFormGroup(
            <FaIcons.FaMinus style={{ marginRight: '5px' }} />,
            "Saldo total Retirado",
            `Total de dinero retirado de la estafeta el día ${todayDate}.`,
            office?.TotalSaldoRetirado || 0
          )}
          {renderFormGroup(
            <FaIcons.FaExchangeAlt style={{ marginRight: '5px' }} />,
            "Saldo en operación",
            "Dinero que ha sido asignado a las cajas de la estafeta más los giros creados menos los giros entregados.",
            office?.TotalSaldoCajas || 0
          )}
        </div>

        <div style={{
          width: "2px",
          background: "#e0e0e0",
          margin: "0 1rem",
        }} />
        <div className="d-flex flex-column" style={{ flex: 1, paddingLeft: "1rem" }}>
          {renderFormGroup(
            <FaIcons.FaArrowDown style={{ marginRight: '5px' }} />,
            "Giros creados",
            `Total de ingresos por giros creados en la estafeta el día ${todayDate}.`,
            office?.TotalRemesasRecibidas || 0
          )}
          {renderFormGroup(
            <FaIcons.FaArrowUp style={{ marginRight: '5px' }} />,
            "Giros por entregar",
            `Suma de dinero de los giros que la estafeta ${office?.name} aún debe entregar.`,
            office?.TotalRemesasPorEntregar || 0
          )}
        </div>
      </div>
      <div className="d-flex justify-content-center align-items-center mt-3">
        <div className="form-group" style={{ minWidth: "350px" }}>
          <div className="box-input-secondary-2" style={{ color: "white" }}>
            <FaIcons.FaBalanceScale style={{ marginRight: '5px' }} />
            <span style={{ fontSize: "1rem" }}> Balance Total</span>
            <span className="tooltip-asterisk">
              <FaQuestionCircle />
              <span className="tooltip-text">
                Suma del saldo actual, más el saldo en operaciones, menos los giros por entregar.
              </span>
            </span>
          </div>
          <input
            type="text"
            className="form-control"
            value={formatCurrency(balanceGeneral || 0)}
            readOnly
          />
        </div>
      </div>
    </div>
  );
};

export default OfficeCard;